import _ from 'lodash';
import React from 'react';
import { DateTime, IconTooltip } from '~/components';
import { useSession } from '~/contexts/SessionContext.jsx';
import { colors } from '~/styles';
import dateFormats from '~/utils/dateFormats.js';

export default function Timestamp({ timestamp = new Date(), dateRange, onClick }) {
  const { isAdmin } = useSession();

  return (
    <IconTooltip
      icon="calendar-alt"
      type="far"
      color={colors.grey25}
      style={{ cursor: isAdmin && _.isFunction(onClick) ? 'pointer' : 'help' }}
      onClick={isAdmin ? onClick : null}
      message={
        <>
          {dateRange && (
            <p>
              Data range: <DateTime value={dateRange.start} /> - <DateTime value={dateRange.end} />
            </p>
          )}
          {timestamp && (
            <p>
              Data as of: <DateTime value={timestamp} format={dateFormats.compactDateTime} />
            </p>
          )}
        </>
      }
    />
  );
}
